import type { RouteRecordRaw } from 'vue-router'
import AdminsPage from './AdminsPage.vue'

export const adminsRoutes: RouteRecordRaw[] = [
  {
    path: '/admins',
    name: 'admins',
    component: AdminsPage,
    meta: { layout: 'admin', requiresAuth: true },
  },
]
